import { useContext, useEffect, useState } from "react";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import moment from "moment";
import { Box, Stack, Typography } from "@mui/material";
import { convertMsToTime } from "../../../../utils/functions";
export const TimerComponent = () => {
    const { transaction } = useContext(InvestTransactionContext);
    const [time, setTime] = useState("72h : 00m : 00s")

    useEffect(() => {
        getTime();
        let interval = setInterval(() => {
            getTime();
        }, 1000);
        return () => {
            clearInterval(interval);
        }
        // eslint-disable-next-line
    }, [transaction])

    const getTime = () => {
        if (transaction) {
            let exDate = moment.unix(transaction.expiryDate);
            let today = moment();
            let ms = exDate.diff(today);
            if (ms <= 0) {
                setTime("00h : 00m : 00s");
                return;
            }
            setTime(convertMsToTime(ms))
            // console.log(ms);
            // setTimeout(()=>{
            // getTime();
            // },1000)
        }
        else {
            setTime("72h : 00m : 00s")
        }
    }
    return (
        <Stack spacing={"10px"}>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>Investment reservation will end in:</Typography>
            <Box
                sx={{
                    py: "12px",
                    width: "100%",
                    borderRadius: "10px",
                    border: "1px solid",
                    borderColor: "primary.main",
                    bgcolor: "primary.light",
                    textAlign: "center"
                }}
            >
                <Typography variant="h4" sx={{ color: "primary.main", fontWeight: 600 }}>{time}</Typography>
            </Box>
        </Stack>
    )
}
